<div class="container mx-auto px-4 py-6">
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-gray-800">{{ id ? 'Editar Destaque da Semana' : 'Novo Destaque da Semana' }}</h1>
    <p class="text-gray-600 mt-2">Preencha os campos abaixo</p>
  </div>

  <div *ngIf="loading" class="flex justify-center items-center py-12">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow p-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Slug do Fornecedor *</label>
        <input [(ngModel)]="fornecedorSlug" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md"
          placeholder="ex: floricultura-roses">
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Data Inicial *</label>
        <input [(ngModel)]="dataInicial" type="date" class="w-full px-3 py-2 border border-gray-300 rounded-md">
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Data Final *</label>
        <input [(ngModel)]="dataFinal" type="date" class="w-full px-3 py-2 border border-gray-300 rounded-md">
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Status</label>
        <select [(ngModel)]="isActive" class="w-full px-3 py-2 border border-gray-300 rounded-md">
          <option [ngValue]="true">Ativo</option>
          <option [ngValue]="false">Inativo</option>
        </select>
      </div>

      <div class="md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Imagem {{ id ? '(deixe em branco para manter a atual)' : '*' }}
        </label>
        <input type="file" (change)="onFileSelected($event)" accept="image/*"
          class="w-full px-3 py-2 border border-gray-300 rounded-md">
        <p class="text-xs text-gray-500 mt-1">A imagem será convertida para WebP (máx. 1200px de largura).</p>

        <div *ngIf="uploadProgress > 0 && uploadProgress < 100" class="mt-2">
          <div class="h-2 bg-gray-200 rounded overflow-hidden">
            <div class="h-full bg-green-500 transition-all" [style.width.%]="uploadProgress"></div>
          </div>
          <p class="text-xs text-gray-500 mt-1">{{ uploadProgress }}%</p>
        </div>

        <div *ngIf="imageUrl" class="mt-3">
          <p class="text-xs text-gray-500 mb-1">Pré-visualização:</p>
          <img [src]="imageUrl" alt="Preview" class="w-48 h-32 object-cover rounded border border-gray-300">
        </div>
      </div>

    </div>

    <div class="mt-6 flex gap-2">
      <button (click)="save()" [disabled]="saving"
        class="px-4 py-2 bg-primary text-white rounded-md disabled:opacity-50">
        {{ saving ? 'Salvando...' : 'Salvar' }}
      </button>
      <button (click)="cancel()" class="px-4 py-2 border rounded-md hover:bg-gray-50">Cancelar</button>
    </div>
  </div>
</div>
